// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Comments-cls1__f92f3aac94a4ca86ae62{/*!*/}.Comments-cls2__f72bd390945e3d5df8bd{width:24px;height:16px;margin-left:16px;border-left:1px solid #dddde2;border-left:1px solid var(--stroke-light, #dddde2);border-bottom:1px solid #dddde2;border-bottom:1px solid var(--stroke-light, #dddde2);border-bottom-left-radius:8px}.Comments-cls2__f72bd390945e3d5df8bd.Comments-short___4614e687738fa1c792d{height:12px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "Comments-cls1__f92f3aac94a4ca86ae62",
	"cls2": "Comments-cls2__f72bd390945e3d5df8bd Comments-cls1__f92f3aac94a4ca86ae62",
	"short": "Comments-short___4614e687738fa1c792d"
};
export default ___CSS_LOADER_EXPORT___;
